import { Entity, makeClone } from 'gossamer-unified';
import { InstitutionMember } from './InstitutionMember';
import { InstitutionGroupMember } from './InstitutionGroupMember';

export interface InstitutionGroupMemberViewRow {
  id: number;
  institution_group_id: number;
  created_at: string;
  institution_member_id: number;
  user_id: string;
  is_admin: boolean;
  is_verified: boolean;
  institution_id: number;
}

const clone = makeClone();

export const InstitutionGroupMemberView: Entity<InstitutionGroupMemberViewRow> = {
  id: 'InstitutionGroupMemberView',
  title: 'Institution Group Member View',
  service: 'main',
  rowLabel: (row: InstitutionGroupMemberViewRow) => [row.institution_group_id, row.institution_member_id].join(' / '),
  rowLabelDynamic: (row: InstitutionGroupMemberViewRow) =>
    `<lookup:InstitutionMember:${row.institution_member_id}> / <lookup:InstitutionGroup:${row.institution_group_id}>`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.institution_group_member_view',
  },
  security: [
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: 'institution_id = {adminInstitutionId}',
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['institution_group_id', 'ASC']],
  defaultFilters: [{ fieldId: 'institution_group_id', operator: 'eq', value: '' }],
  fields: {
    id: clone(InstitutionGroupMember.fields.id),
    institution_group_id: clone(InstitutionGroupMember.fields.institution_group_id),
    institution_member_id: clone(InstitutionGroupMember.fields.institution_member_id, { listColumn: false }),
    created_at: clone(InstitutionGroupMember.fields.created_at),
    user_id: clone(InstitutionMember.fields.user_id),
    is_admin: clone(InstitutionMember.fields.is_admin),
    is_verified: clone(InstitutionMember.fields.is_verified),
    institution_id: clone(InstitutionMember.fields.institution_id),
  },
};
